import { useState, useEffect, useMemo } from "react"
import { Card } from "react-bootstrap"
import Trailer from "./Trailer"
import LineGraph from "./LineGraph"
import LoadingTimes from "./LoadingTimes"
import BOLErrors from "./BOLErrors"
import { allColors } from "../helpers"
import { useDispatch, useSelector } from "react-redux"
import { CardFrame } from "components/UI/CardFrame"
import { getWarehouseDashboard } from "redux/warehouse/warehouseSlice"

const Dashboard = () => {
  const dispatch = useDispatch()
  const data = useSelector((state) => state.warehouse.dashboardData)
  const [timeRange, setTimeRange] = useState(7)
  const [loading, setLoading] = useState(true)
  const [loadingData, setLoadingData] = useState([])
  const [colorSet, setColorSet] = useState([])
  const timeKey = { 7: "week", 28: "month", 360: "year" }
  const warehouse = useSelector((state) => state.warehouse.warehouse)

  const handleLoadingToggle = (clickValue) => {
    if (clickValue === "Loading") {
      setLoading(true)
    } else {
      setLoading(false)
    }
  }

  useEffect(() => {
    dispatch(
      getWarehouseDashboard(timeRange)
    )
  }, [timeRange, warehouse])

  useEffect(() => {
    if ("loading_times" in data) {
      if (loading) {
        setLoadingData(data.loading_times.loading)
        setColorSet([
          allColors.outgoingBuses.dark,
          allColors.outgoingOrders.dark,
        ])
      } else {
        setLoadingData(data.loading_times.unloading)
        setColorSet([
          allColors.incomingBuses.dark,
          allColors.incomingOrders.dark,
        ])
      }
    }
  }, [data, loading])

  const volumeTitleComponent = useMemo(() => (
    <>
      Last
      <select
        value={timeRange}
        className="card-header-select"
        onChange={(e) => setTimeRange(e.target.value)}
      >
        <option value={7}>week</option>
        <option value={28}>month</option>
        <option value={360}>year</option>
      </select>{" "}
      Overview
    </>
  ), [timeRange]);

  const averageLoadingTimeTitleComponent = useMemo(() => (
    <>
      Last {timeKey[timeRange]} average{" "}
      <select
        className="card-header-select"
        onChange={(e) => handleLoadingToggle(e.target.value)}
      >
        <option value='Loading'>Loading</option>
        <option value='Unloading'>Unloading</option>
      </select>{" "}
      times
    </>
  ), []);

  const bolErrorTitleComponent = useMemo(() => (
    <>
      Last
      <select
        value={timeRange}
        className="card-header-select"
        onChange={(e) => setTimeRange(e.target.value)}
      >
        <option value='7'>week</option>
        <option value='28'>month</option>
        <option value='360'>year</option>
      </select>{" "}
      BOL errors
    </>
  ), [timeRange]);

  return (
    <>
      <h4 className="warehouse-main-header-title">
        Available Trailers - <span className={`${warehouse}-text`}>{warehouse}</span>
      </h4>
      <Trailer trailerData={data.trailers} />

      <div className="row mt-4">
        <div className="col-lg-12">
          <CardFrame title={volumeTitleComponent} cardClass={"mt-0"}>
            <LineGraph data={data} colors={allColors} />
          </CardFrame>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4 col-md-12">
          <CardFrame title={averageLoadingTimeTitleComponent} cardClass={"mt-0"}>
            <LoadingTimes
              data={loadingData}
              loading={loading}
              colors={colorSet}
            />
          </CardFrame>
        </div>
        <div className="col-lg-8 col-md-12">
          <CardFrame title={bolErrorTitleComponent} cardClass={"mt-0"}>
            <BOLErrors data={data} colors={allColors} />
          </CardFrame>
        </div>
      </div>

    </>
  )
}

export default Dashboard
